import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { GlobalBannerService } from '../shared/components/global-banner/global-banner.service';
import { IState } from './credit-memo-data.reducer';
import { DocumentDataDispatcher } from '../document-data/document-data.dispatcher';
import { CreditMemo } from './credit-memo.model';
import { CreditMemoDataStore } from './credit-memo-data.store';
import { CreditMemoDataBuilder } from './credit-memo-data.builder';
import { SettingsDataStore } from '../settings-data/settings-data.store';

@Injectable()
export class CreditMemoDataDispatcher extends DocumentDataDispatcher<
  IState,
  CreditMemo
> {
  constructor(
    store: Store<any>,
    creditMemoDataStore: CreditMemoDataStore,
    settingsDataStore: SettingsDataStore,
    creditMemoDataBuilder: CreditMemoDataBuilder,
    globalBannerService: GlobalBannerService,
    translateService: TranslateService
  ) {
    super(
      store,
      creditMemoDataStore,
      settingsDataStore,
      creditMemoDataBuilder,
      globalBannerService,
      translateService
    );
  }
}
